import { gql } from "@apollo/client";
import client from "../apolloClient";
import {
  TenantConfiguration,
  UpdateTenantConfigurationInput,
  UpdateTenantConfigurationPayload,
} from "../../schemas/tenantConfigurationSchema";

const GET_TENANT_CONFIGURATION = gql`
  query GetTenantConfiguration($tenantId: ID!) {
    tenantConfiguration(tenantId: $tenantId) {
      id
      tenantId
      tenantPlaylistCreativesPerSlot
      clientPlaylistCreativeLimit
      clientPlaylistCreativesPerSlot
      clientCreativePlayDuration
      tenantCreativePlayDuration
      liveWidgets
      createdAt
      updatedAt
      tenant {
        id
      }
    }
  }
`;

const UPDATE_TENANT_CONFIGURATION = gql`
  mutation UpdateTenantConfiguration(
    $tenantId: ID!
    $input: UpdateTenantConfigurationInput!
  ) {
    updateTenantConfiguration(tenantId: $tenantId, input: $input)
  }
`;

export const tenantConfigurationService = {
  getByTenantId: async (
    tenantId: string
  ): Promise<TenantConfiguration | null> => {
    const { data } = await client.query({
      query: GET_TENANT_CONFIGURATION,
      variables: { tenantId },
      fetchPolicy: "network-only",
    });
    return data.tenantConfiguration;
  },

  update: async (
    payload: UpdateTenantConfigurationPayload
  ): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: UPDATE_TENANT_CONFIGURATION,
      variables: {
        tenantId: payload.tenantId,
        input: payload.configuration,
      },
    });
    return data.updateTenantConfiguration;
  },
};
